import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { serverError } from './../../../../core/models/messages';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TimesheetService } from './../../../../core/services/services/timesheet.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, finalize, forkJoin, takeUntil } from 'rxjs';
import { CandidatService } from '@core/services/candidat-service/candidat.service';

@Component({
  selector: 'app-details-cra-candidat',
  templateUrl: './details-cra-candidat.component.html',
  styleUrls: ['./details-cra-candidat.component.css'],
})
export class DetailsCraCandidatComponent {
  selectedValues: any[] = [];
  allSelectedValues: any[] = [];
  listOfCra: any;
  idCra: any;
  custom_role_id: any;
  listDetailsCraForMonths: any;
  totalTypeOfCra: any;
  rowIndex!: number;
  numberOfDays!: number;
  addCraData: any;
  totalClientOfCra: any;
  listClientOfCra: any;
  durationCra: any;
  typeIds: any = [];
  totalDurations: any[] = [];
  totalDurationByfamilyByType: any;
  totalDurationForAllFamilies: any;
  type_id!: number;
  unknownFamily: boolean = false;
  unknownType: boolean = false;
  companyId: any;
  company_name:any
  userId: any;
  id: any;
  esn: any;
  listProjectsOfCra:any
  consultantfirstname: any;
  consultantlastname: any;
  country: any;
  res = [
    { id: 1, name: '0.25' },
    { id: 2, name: '0.5' },
    { id: 3, name: '0.75' },
    { id: 4, name: '1' },
  ];
  selectedCandidate: any;

  selectedValuesControls: { [key: number]: FormControl[] } = {};
  testArray: any = [1, 2, 3];
  modelSlect = '1';
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  holidays: string[] = [];
  currentDate: Date = new Date();
  constructor(
    private Timeshettservice: TimesheetService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private candidatService: CandidatService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.companyId = this.localStorageService.getData('clientConnected');
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')
    this.userId = connectedUser?.uuid;
    this.getCandidateById();
    this.getlistProjectsOfCra()
    forkJoin([this.getId()]).subscribe(() => {
      this.getDetailsListCra();
    });
  }
  getCandidateById() {
    this.spinner.show();
    this.candidatService
      .getUserById(this.userId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          console.log('res', res);
          this.selectedCandidate = res.data;
          this.company_name=this.selectedCandidate?.company_name
          this.getListTypeOfCra(this.company_name);
          console.log('selected candidat', this.selectedCandidate);
          this.spinner.hide();
        },
        error: (err) => {
          console.log('err', err);
          this.spinner.hide();
        },
      });
  }
  getId(): Observable<void> {
    return new Observable((observer) => {
      this.activatedRoute.paramMap.subscribe({
        next: (params: any) => {
          this.idCra = params.params['idCra'];
          this.custom_role_id = params.params['roleId'];
          observer.next();
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }
  companyName:any
  getListTypeOfCra(company_name:any) {
    this.companyName = this.localStorageService.getData('clientConnectedName');

    this.spinner.show();
    if(this.companyName){
      this.companyName = this.companyName
    }else{
      this.companyName=company_name
    }
    this.Timeshettservice.getAllTypeactivitétimesheet(this.companyName)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res type activite', res);
          this.listOfCra = res.data.items;

          console.log('res', this.listOfCra);

          this.typeIds = [];
          for (const type of this.listOfCra) {
            this.typeIds.push(type.id);
          }

          console.log('typeIds_typeIds', this.typeIds);
          this.totalTypeOfCra = res.data.count;
          console.log('totalTypeOfCra', this.totalTypeOfCra);
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getTotalDurationByTypeProduction(): any[] {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType.Production
    );
  }
  getTotalDurationByTypeAbsence(): any[] {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType.Absence
    );
  }

  getTotalDurationByTypeInterne(): any[] {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType.Interne
    );
  }
  getDetailsListCra() {
    let dataPayload = this.idCra;
    let datajourfeerie = 'fr';
    let company_id = this.companyId;
    this.spinner.show();
    this.Timeshettservice.getDetailtimesheetJourfeerie(
      datajourfeerie,
      dataPayload,
      company_id
    )
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          console.log('res', res);
          this.listDetailsCraForMonths = res?.data;
          console.log(
            'data listDetailsCraForMonths ',
            this.listDetailsCraForMonths
          );
          this.consultantfirstname =
            this.listDetailsCraForMonths.consultant.first_name;
          this.consultantlastname =
            this.listDetailsCraForMonths.consultant.first_name;
          this.esn = this.listDetailsCraForMonths.ESN.name;
          console.log('esn', this.esn.name);
          const numberOfRows = Number(this.numberOfRows);
          const numberOfDays = Number(
            this.listDetailsCraForMonths?.numberOfDays
          );
          this.selectedValues = Array.from({ length: numberOfRows }, () =>
            Array.from({ length: numberOfDays }, () => null)
          );

          for (const cra of this.listDetailsCraForMonths?.desiredTimeSheet
            ?.ligne_time_sheet) {
            const type_id = cra.type_id;

            for (const day of cra.days) {
              const dayIndex = day.day - 1;
              const duration = day.duration ? parseInt(day.duration) : null;

              if (!this.selectedValues[type_id]) {
                this.selectedValues[type_id] = [];
              }

              if (!this.selectedValues[type_id][dayIndex]) {
                this.selectedValues[type_id][dayIndex] = { duration: null };
              }

              this.selectedValues[type_id][dayIndex].duration = duration;
            }
          }

          console.log('selectedValues', this.selectedValues);
          for (const totalDuration of this.listDetailsCraForMonths
            ?.desiredTimeSheet?.total_duration_by_day) {
            const dayIndex = totalDuration.day - 1;
            this.totalDurations[dayIndex] = totalDuration.total_duration;
          }
          console.log('totalDurations', this.totalDurations);
          this.totalDurationByfamilyByType =
            this.listDetailsCraForMonths?.desiredTimeSheet?.totalDurationByfamilyByType;
          this.totalDurationForAllFamilies =
            this.listDetailsCraForMonths?.desiredTimeSheet?.totalDurationForAllFamilies;
          console.log(
            'totalDurationByfamilyByType',
            this.totalDurationByfamilyByType
          );
          console.log(
            'totalDurationForAllFamilies',
            this.totalDurationForAllFamilies
          );

          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.error('Error fetching listDetailsCraForMonths:', error);
        }
      );
  }
  getlistProjectsOfCra() {
    this.spinner.show();
    this.Timeshettservice
      .getProjetByCandidate(this.userId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listProjectsOfCra = res.data;
          console.log('listProjectsOfCra', this.listProjectsOfCra);
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getTypeName(typeId: number): string | undefined {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType[typeId]?.[0]?.type_name
    );
  }

  getTotalDurationByType(typeId: number): any[] {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType[typeId]
    );
  }

  generateDaysArray(): number[] {
    return Array.from(
      { length: this.listDetailsCraForMonths?.numberOfDays },
      (_, index) => index + 1
    );
  }

  get numberOfRows(): number[] {
    return Array.from({ length: this.totalTypeOfCra }, (_, index) => index + 1);
  }

  isWeekend(day: number): boolean {
    if (
      !this.listDetailsCraForMonths?.weekends ||
      this.listDetailsCraForMonths.weekends.length === 0
    ) {
      return false;
    }

    const firstWeekendDate = this.listDetailsCraForMonths.weekends[0];
    const yearMonth = firstWeekendDate.substring(0, 7);

    const dayString = day < 10 ? `0${day}` : `${day}`;
    const formattedDate = `${yearMonth}-${dayString}`;

    return this.listDetailsCraForMonths.weekends.includes(formattedDate);
  }
  isHoliday(day: number): boolean {
    if (
      !this.listDetailsCraForMonths?.holidays ||
      this.listDetailsCraForMonths.holidays.length === 0
    ) {
      return false;
    }

    const firstWeekendDate = this.listDetailsCraForMonths.holidays[0];
    const yearMonth = firstWeekendDate.substring(0, 7);

    const dayString = day < 10 ? `0${day}` : `${day}`;
    const formattedDate = `${yearMonth}-${dayString}`;

    return this.listDetailsCraForMonths.holidays.includes(formattedDate);
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }

  // Initialisez les contrôles de formulaire
  initializeFormControls() {
    this.listDetailsCraForMonths?.desiredTimeSheet?.ligne_time_sheet.forEach(
      (cra: any) => {
        this.selectedValuesControls[cra.type_id] = cra.days.map(
          () => new FormControl()
        );
      }
    );
  }
  updateSelectedValue(value: any, type_id: number, day: number) {
    if (!this.selectedValues[type_id]) {
      this.selectedValues[type_id] = Array.from(
        { length: this.listDetailsCraForMonths.numberOfDays },
        () => null
      );
    }
    this.selectedValues[type_id][day] = value;
    console.log(`Selected value for type_id ${type_id}, day ${day}:`, value);

    // Assume listOfCra is an array with objects having id and other properties
    this.allSelectedValues.push({
      type_id: type_id,
      duration: value,
      day: day + 1,
    });
    console.log('All selected values:', this.allSelectedValues);

    let data = {
      date: this.listDetailsCraForMonths?.desiredTimeSheet?.date,
      projectCandidate_id:
        this.listDetailsCraForMonths?.desiredTimeSheet?.projectCandidate_id,
      ligneCra: this.allSelectedValues,
    };
    console.log('Data to be added:', data);
    this.addCraData = data;
  }

  remplirLigne(typeId: number): void {
    const rowIndex =
      this.listDetailsCraForMonths?.desiredTimeSheet?.ligne_time_sheet.findIndex(
        (cra: any) => cra.type_id === typeId
      );

    if (rowIndex !== -1) {
      this.listDetailsCraForMonths?.desiredTimeSheet?.ligne_time_sheet[
        rowIndex
      ].days.forEach((day: any) => {
        day.duration = 1;
      });
    }
  }

  exportToPDF() {
    const element = document.getElementById('downloadCra');

    if (element) {
      this.spinner.show();
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('export_Cra.pdf');
        this.spinner.hide();
      });
    } else {
      console.error('Element not found!');
    }
  }
  getClassForDuration(duration: number): string {
    switch (duration) {
      case 1:
        return 'duration-1';
      case 4:
        return 'duration-4';
      case 2:
        return 'duration-2';
      default:
        return 'default-duration';
    }
  }
  rejectTimesheet() {
    let data = {
      time_sheet_id: this.idCra,
      custom_role_id: this.custom_role_id,
      state: '2',
    };
    this.Timeshettservice.rejectAndValidateCra(
      data,
      this.companyId,
      this.userId
    ).subscribe({
      next: (res: any) => {
        console.log('res', res);
        this.toastr.success('Timesheet a été rejeté avec succès.');
      },
      error: (error) => {
        this.toastr.error(serverError);
      },
    });
  }
  validateTimesheet() {
    let data = {
      time_sheet_id: this.idCra,
      custom_role_id: this.custom_role_id,
      state: '1',
    };
    this.Timeshettservice.rejectAndValidateCra(
      data,
      this.companyId,
      this.userId
    ).subscribe({
      next: (res: any) => {
        console.log('res', res);
        this.toastr.success('Timesheet a été Validé avec succès.');
      },
      error: (error) => {
        this.toastr.error(serverError);
      },
    });
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
